export enum PolygonShape {
  POLYGON = 0,
  CIRCLE = 1,
  RECTANGLE = 2
}
